import { SVGProps } from 'react'

export const ApprovedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="23"
    height="21"
    viewBox="0 0 23 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 2.99985H7M14 4.99985L7.83447 6.76143C7.52956 6.84855 7.37711 6.8921 7.25117 6.97398C7.13969 7.04647 7.04379 7.14045 6.96907 7.25045C6.88466 7.3747 6.83803 7.52625 6.74477 7.82933L3 19.9998M3 19.9998L15.1705 16.2551C15.4736 16.1618 15.6251 16.1152 15.7494 16.0308C15.8594 15.9561 15.9534 15.8602 16.0259 15.7487C16.1077 15.6227 16.1513 15.4703 16.2384 15.1654L18 8.99985M3 19.9998L9.586 13.4138M20.8686 5.86848L17.1314 2.13122C16.7354 1.7352 16.5373 1.53719 16.309 1.46301C16.1082 1.39775 15.8918 1.39775 15.691 1.46301C15.4627 1.53719 15.2646 1.7352 14.8686 2.13122L14.1314 2.86848C13.7354 3.2645 13.5373 3.4625 13.4632 3.69083C13.3979 3.89168 13.3979 4.10802 13.4632 4.30887C13.5373 4.53719 13.7354 4.7352 14.1314 5.13122L17.8686 8.86848C18.2646 9.2645 18.4627 9.4625 18.691 9.53669C18.8918 9.60195 19.1082 9.60195 19.309 9.53669C19.5373 9.4625 19.7354 9.26449 20.1314 8.86848L20.8686 8.13122C21.2646 7.7352 21.4627 7.53719 21.5368 7.30887C21.6021 7.10802 21.6021 6.89168 21.5368 6.69083C21.4627 6.4625 21.2646 6.26449 20.8686 5.86848ZM11 9.99985C12.1046 9.99985 13 10.8953 13 11.9998C13 13.1044 12.1046 13.9998 11 13.9998C9.89543 13.9998 9 13.1044 9 11.9998C9 10.8953 9.89543 9.99985 11 9.99985Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
